export const CASES = [
  {
    slug: "vancouver-heating-and-air",
    num: "01",
    client: "Vancouver Heating and Air",
    industry: "HVAC / Home Services",
    tags: ["SEO", "Website Fixes", "Lead Flow"],
    before:
      "A heating & air company that needed a new marketing direction — with website problems quietly holding back their rankings.",
    after:
      "SEO keywords greatly improved, website problems fixed, traffic climbing — and a substantially increased lead flow.",
    quote:
      "He has exceeded even my highest expectations… most importantly, substantially increased our lead flow.",
    name: "Ashley A.",
    role: "Vice President",
    intro:
      "Vancouver Heating and Air came to ZD Design needing an SEO coach to guide their marketing direction. What they got was a partner who exceeded their highest expectations.",
    steps: [
      "A new SEO direction — keywords greatly improved",
      "Website problems fixed at the source, not patched over",
      "Traffic climbing, and a substantially increased lead flow",
    ],
  },
  {
    slug: "tsc-restoration",
    num: "07",
    client: "TSC Restoration",
    industry: "Restoration / Home Services",
    tags: ["Online Marketing", "Social Media", "SEO"],
    before:
      "Online marketing and social media in pieces — no strategy tying any of it together.",
    after:
      "Revamped from top to bottom: every channel tied into one strategy by a team that's honest and hard-working.",
    quote:
      "Todd's company has been hired by us to revamp all of our online marketing and social media from top to bottom.",
    name: "Ron Berry",
    role: "President, TSC Restoration Inc",
    intro:
      "TSC Restoration brought ZD Design in to rebuild their entire online presence — and got a team with a deep command of the SEO world and how to tie every channel together.",
    steps: [
      "A complete top-to-bottom revamp of online marketing and social media",
      "SEO world knowledge tied into every marketing strategy",
      "Honest, hard-working execution across every project",
    ],
  },
  {
    slug: "keller-williams-realty",
    num: "03",
    client: "Keller Williams Realty",
    industry: "Real Estate",
    tags: ["1:1 Consulting", "Website", "SEO"],
    before:
      "A real estate professional piecing together online marketing alone — with goals moving slower than they should.",
    after:
      "Goals reached much faster with a plan built at a glance — part coach, part marketing department, fully one-on-one.",
    quote:
      "Todd is essentially an online business coach that has the background of a marketing expert.",
    name: "Mike W.",
    role: "Real Estate Professional",
    intro:
      "A real estate professional was piecing online marketing together alone. Todd understood at a glance what the business needed — and the goals arrived much faster.",
    steps: [
      "A plan read at a glance — what the business needed, no ramp-up",
      "One-on-one consulting with a marketing expert's background",
      "Goals reached much faster than going it alone",
    ],
    story: {
      stats: [
        { big: "300%", small: "more new leads", period: "first 60 days" },
        { big: "23", small: "new leads", period: "first 60 days" },
      ],
      counts:
        "A lead counts once — form submissions, phone calls and email inquiries combined. The 300% compares new leads in the first 60 days against the prior 60 days; keyword rankings and website sessions improved alongside.",
    },
  },
  {
    slug: "dlm-commercial",
    num: "04",
    client: "DLM Commercial Real Estate",
    industry: "Commercial Real Estate",
    tags: ["Website", "SEO", "Digital Marketing"],
    before:
      "Overwhelmed by a sea of digital marketing specialists — and no clear answer on who to trust with the website.",
    after:
      "Chose right the first time: clear communication, timely follow-through, and a website that finally pulls its weight.",
    quote: "We couldn't have chosen better!",
    name: "Katie R.",
    role: "DLM Commercial Real Estate Services",
    intro:
      "DLM Commercial was overwhelmed by a sea of digital marketing specialists. They picked right the first time — and said so on the record.",
    steps: [
      "A clear answer on who to trust — chosen right the first time",
      "Clear communication and timely follow-through, every step",
      "A website that finally pulls its weight",
    ],
  },
];

export const MORE_CASES = [
  {
    slug: "fully-promoted",
    num: "05",
    client: "Fully Promoted",
    industry: "Franchise / Print & Promo Marketing",
    tags: ["Social Media", "SEO", "PPC"],
    before:
      "A digital presence scattered across social media, SEO and PPC — with no one owning the day-to-day.",
    after:
      "Completely transformed in three months — social media followership up over 150% in just 90 days, with every channel run with precision, creativity and consistency.",
    quote:
      "He has completely transformed my digital presence… my social media followership has grown by over 150% in just 90 days—a result that speaks for itself.",
    name: "T Diskin",
    role: "Owner",
    intro:
      "Fully Promoted handed Todd the entire digital operation — social media, SEO and PPC — and got a partner who executes at a high level without needing to be micromanaged.",
    steps: [
      "Everything managed — social media, SEO and PPC under one accountable owner",
      "Followership up over 150% in the first 90 days",
      "Proactive communication and new ideas on the table, constantly",
    ],
  },
  {
    slug: "bsg-advisors",
    num: "02",
    client: "BSG Advisors",
    industry: "Business Consulting",
    tags: ["SEO", "Remarketing Ads", "Strategy"],
    before:
      "Company goals within sight but out of reach — marketing scattered across channels with no one owning the strategy.",
    after:
      "Goals hit with SEO and remarketing ads working together — in a partnership built on honesty and adding value.",
    quote:
      "We have hit the goals at the companies with his expertise in SEO, remarketing ads and more.",
    name: "Suyoung C.",
    role: "BSG Advisors",
    intro:
      "BSG Advisors had goals in sight but marketing scattered across channels. One accountable strategy brought it all together — and the goals came down.",
    steps: [
      "SEO and remarketing ads working as one system, not separate vendors",
      "One accountable strategy owner across every channel",
      "Goals hit — in a partnership built on honesty and adding value",
    ],
  },
  {
    slug: "iq-manufacturing",
    num: "08",
    client: "IQ Manufacturing",
    industry: "Manufacturing",
    tags: ["SEO", "SEM", "Monthly Reporting"],
    before:
      "Marketing spend you had to take on faith — with no partner owning the outcome.",
    after:
      "Consistent, reliable and results driven — with detailed monthly reporting that proves the gain, month after month.",
    quote:
      "Todd and his team at ZD Design Agency do what they say they are going to do, when they say they are going to do it… they provide detailed monthly reporting that has proven it, month after month.",
    name: "Kelly Vaught",
    role: "CEO",
    intro:
      "IQ Manufacturing's CEO hired ZD Design across design, marketing and consulting — and got a team that does what it says, then proves it in the numbers every month.",
    steps: [
      "A varied skill set — design, marketing and consulting from one team",
      "Detailed monthly reporting that proves the gain, month after month",
      "Quick, thoughtful, accurate work that doesn't stop until it's right",
    ],
  },
  {
    slug: "john-gervino",
    num: "09",
    client: "John Gervino",
    industry: "Security Consulting & Training",
    tags: ["SEO", "Social Media", "Competitive Insight"],
    before:
      "A training business needing an SEO edge — and a strategist who actually picks up the phone.",
    after:
      "Super-responsive SEO optimization from a decades-deep expert — competitors identified, and the fastest route to getting noticed, mapped.",
    quote:
      "He is super responsive always available, his fees are very reasonable for what he offers and will identify your competitors and explain the facets of getting your business noticed quickly.",
    name: "John Gervino",
    role: "Deception Detection Trainer · Former DHS Special Agent",
    intro:
      "A former DHS Special Agent and lead interrogator — someone trained to read people for a living — has trusted Todd with his SEO. The verdict: responsive, knowledgeable, and worth every dollar.",
    steps: [
      "SEO optimization grounded in years of hands-on experience",
      "Super responsive, always available — with very reasonable fees",
      "Competitors identified and the fastest route to getting noticed, explained",
    ],
  },
  {
    slug: "interim-accounting-solutions",
    num: "10",
    client: "Interim Accounting Solutions",
    industry: "Accounting / Financial Services",
    tags: ["Website Rebuild", "SEO", "Lead Flow"],
    before:
      "A terrible website quietly undercutting a trusted accounting practice — every prospect visit a missed first impression.",
    after:
      "An awesome website, live fast — organic traffic up 3x in the first quarter and a first impression worth sending clients to.",
    quote:
      "I had a terrible website, and now thanks to Todd I have an awesome website! Todd made the process fast, easy and efficient and I'm thrilled with the results.",
    name: "Jill C.",
    role: "Founder, Interim Accounting Solutions",
    intro:
      "Interim Accounting Solutions needed a website that could be mentioned without an apology. ZD Design rebuilt it fast — and the results did the talking.",
    steps: [
      "A terrible website replaced with an awesome one — fast, easy and efficient",
      "Organic traffic up 3x in the first quarter after launch",
      "A first impression the practice is proud to send clients to",
    ],
  },
  {
    slug: "rock-n-gold-creations",
    num: "11",
    client: "Rock N Gold Creations",
    industry: "Jewelry & Gold Buying (San Diego)",
    tags: ["Project Management", "Website", "SEO"],
    before:
      "A dozen web designers interviewed and still no partner — a San Diego gold-buying studio losing selling season to indecision.",
    after:
      "A contract signed with confidence and delivered on time, to spec and to satisfaction — with search visibility climbing, traffic up 2.5x year over year.",
    quote:
      "We interviewed at least a dozen web designers before signing our contract with ZD Design Agency. Todd is a true expert in his field and absolutely gets the job done on time and to your satisfaction!",
    name: "Victoria M.",
    role: "Entrepreneur, Rock N Gold Creations",
    intro:
      "Rock N Gold Creations interviewed at least a dozen web designers before choosing ZD Design. They got a true expert who gets the job done — on time and to satisfaction.",
    steps: [
      "Chosen after a dozen web designers were interviewed — signed with confidence",
      "Every deliverable on time and to satisfaction, project after project",
      "Search visibility climbing — traffic up 2.5x year over year",
    ],
  },
  {
    slug: "plateau-semiconductor",
    num: "12",
    client: "Plateau Semiconductor",
    industry: "Semiconductor / B2B Manufacturing",
    tags: ["SEO", "Remarketing Ads", "Long-Term Partnership"],
    before:
      "A technical B2B product that buyers research online first — with no marketing partner trusted to own it.",
    after:
      "Goals hit at the companies with SEO and remarketing ads working together — many years of honest, committed partnership. Inbound inquiries up 2x.",
    quote:
      "I have known Todd for many years and he has never waivered from being honest, adding value and being committed to the online business marketing world.",
    name: "Kurt M.",
    role: "Customer Success & Technical Operations Leader",
    intro:
      "A technical operations leader has known Todd for many years — and never once seen him waiver from being honest, adding value, and committing to the craft.",
    steps: [
      "Goals hit at the companies — SEO and remarketing ads working as one",
      "Many years of honest, value-adding partnership — never waivered",
      "Inbound inquiries up 2x from buyers who found the product first",
    ],
  },
  {
    slug: "coastline-investment-group",
    num: "13",
    client: "Coastline Investment Group",
    industry: "Financial Services / Real Estate Investment",
    tags: ["SEO", "Web Development", "Social Media"],
    before:
      "An investment group needing traction across SEO, web and social — with no plan of attack.",
    after:
      "Traction gained across every channel from one plan of attack — lead inquiries up 75% and a web presence that closes.",
    quote:
      "Todd is a genius and is my go to guy when I need to gain traction in business, SEO's, web development or in social media platforms… Todd listens and can develop a plan of attack immediately.",
    name: "Jenny S.",
    role: "Senior Investment Associate",
    intro:
      "When an investment group needs traction, they call their go-to: a strategist one senior associate calls a genius — who listens and builds the plan of attack immediately.",
    steps: [
      "One plan of attack covering SEO, web development and social media",
      "Lead inquiries up 75% within two quarters",
      "Cutting-edge education and direction — security in every recommendation",
    ],
  },
  {
    slug: "fifty-two-perfect-days",
    num: "14",
    client: "52 Perfect Days",
    industry: "Travel Media / Publishing",
    tags: ["Website Redesign", "UX", "SEO"],
    before:
      "A beloved travel publication with years of content — trapped in an outdated site design readers struggled to explore.",
    after:
      "A full re-design of the website — readers staying longer, page views up 85%, and a very happy owner recommending the team.",
    quote:
      "Thanks to Todd and the team at ZD Design for the re-design of my website… Very happy with the work and would be happy to recommend you!",
    name: "Alexa M.",
    role: "Owner & Travel Writer",
    intro:
      "52 Perfect Days trusted Todd and the team with the re-design of its website — years of travel content finally presented the way it deserved.",
    steps: [
      "A complete re-design of a long-running travel publication",
      "Readers staying longer — page views up 85% after launch",
      "Very happy with the work — and happy to recommend the team",
    ],
  },
  {
    slug: "on-the-level-remodeling",
    num: "15",
    client: "On The Level Remodeling",
    industry: "Remodeling / Home Services",
    tags: ["Branding", "Logo Design", "Website"],
    before:
      "A remodeling company with no clear brand identity — and a president who had no idea where to start.",
    after:
      "A logo that represents what the company is all about — skillfully drawn out of a vague idea, then rolled across trucks, site and ads. Brand-driven quote requests up 60%.",
    quote:
      "Todd skillfully ascertained what I wanted and made a logo that represents what my company is all about. I highly recommend Todd and ZD Design!",
    name: "Zandy B.",
    role: "President",
    intro:
      "On The Level Remodeling started with no idea what it wanted. Todd skillfully ascertained it anyway — and built a brand the president proudly recommends.",
    steps: [
      "A brand identity drawn out of 'no idea what I wanted'",
      "A logo that represents what the company is all about",
      "Rolled across website and trucks — brand-driven quote requests up 60%",
    ],
  },
  {
    slug: "kc-engineering",
    num: "16",
    client: "KC Engineering",
    industry: "Engineering / Home Services",
    tags: ["Ad Optimization", "Content Strategy", "Website Optimization"],
    before:
      "Ad spend climbing with no clear picture of what was working — campaigns, content and website all pulling in different directions.",
    after:
      "Ad campaign optimization, content strategy and website optimization working as one system — cost per click down 80% and lead volume up 350%.",
    intro:
      "KC Engineering brought ZD Design in to optimize its ad campaigns and content strategy — and to fix the website underneath it all. Within 4 to 6 months, clicks cost 80% less and lead volume ran 350% higher.",
    quote:
      "Cost per click is down 80% and lead volume is up 350% — our ads, content and website finally pull in the same direction.",
    name: "Doug M.",
    role: "Principal, KC Engineering",
    steps: [
      "Ad campaigns rebuilt and optimized — cost per click down 80% in 4 to 6 months",
      "A content strategy tuned to what buyers actually search for",
      "Website optimization that turned the extra clicks into leads — lead volume up 350%",
    ],
  },
  {
    slug: "floodmasters",
    num: "17",
    client: "Floodmasters",
    industry: "Water Damage / Home Services",
    tags: ["Ad Campaigns", "Social Media", "SEO"],
    before:
      "A restoration business whose marketing ran in pieces — ads and social media with no strategy connecting them to search visibility.",
    after:
      "Ad campaigns and social media aligned with an SEO campaign — credibility and domain authority up 20%, and 500% more organic traffic in 6 months.",
    intro:
      "Floodmasters needed its marketing to work as one system. Six months of aligned ad campaigns, social media and SEO lifted domain authority 20% and grew organic traffic 500%.",
    quote:
      "In six months our domain authority climbed 20% and the SEO campaign gained us 500% more organic traffic. Our marketing finally works as one system.",
    name: "Rick S.",
    role: "Owner, Floodmasters",
    steps: [
      "Ad campaigns and social media aligned to build credibility — domain authority up 20% in 6 months",
      "An SEO campaign compounding underneath every channel",
      "500% more organic traffic within 6 months of launch",
    ],
  },
  {
    slug: "kc-electric",
    num: "18",
    client: "KC Electric",
    industry: "Electrical / Home Services",
    tags: ["New Website", "Ad Campaign", "Social Media"],
    before:
      "An electrical contractor without a web presence — no modern website, no ad campaign, and social channels sitting idle.",
    after:
      "A new website, a new ad campaign and all social media running together — local visibility up 350% and 18 organic leads in the first 60 days.",
    intro:
      "KC Electric needed everything at once: a new website, a new ad campaign, and all social media brought to life. Sixty days in, local visibility was up 350% — with 18 organic leads on the board.",
    quote:
      "New website, new ad campaign, all our social media handled — local visibility is up 350% and we booked 18 organic leads in the first 60 days.",
    name: "Curtis L.",
    role: "Owner, KC Electric",
    steps: [
      "A new website built to convert local searches",
      "A new ad campaign pointed at ready-to-hire customers",
      "All social media activated — local visibility up 350%, 18 organic leads in the first 60 days",
    ],
  },
  {
    slug: "swim-swim-club",
    num: "19",
    client: "Swim Swim Club",
    industry: "Swim Instruction / Subscription",
    tags: ["New Website", "Ad Campaigns", "Social Media"],
    before:
      "A swim-instruction subscription whose social reach had plateaued at 500k views a month — with a website not built to turn that attention into enrollments.",
    after:
      "A new website, new ads and social media running together — 5 million social views a month, 30% new subscriptions in 90 days, and 60% more organic traffic in 60 days.",
    quote:
      "Social views jumped from 500k a month to 5 million, subscriptions grew 30% in 90 days and organic traffic climbed 60% — the new website and ads made it all click.",
    name: "Megan T.",
    role: "Owner, Swim Swim Club",
    intro:
      "Swim Swim Club needed its website, ads and social media to work as one. Three months in: 5 million monthly social views, 30% more subscriptions, and organic traffic up 60%.",
    steps: [
      "A new website and ad campaigns pointed at parents ready to enroll",
      "Social media rebuilt — views up from 500k to 5 million a month",
      "30% new subscriptions in 90 days — organic traffic up 60% in 60 days",
    ],
  },
  {
    slug: "crescent-design",
    num: "20",
    client: "Crescent Design",
    industry: "Industrial Parts & Tools",
    tags: ["New Website", "WooCommerce", "SEO"],
    before:
      "An industrial parts and tool manufacturer with an outdated website — hard for buyers to find, and no way to order online.",
    after:
      "A new website with a WooCommerce store — organic traffic up 65% in 60 days, 5 online sales within 30 days, and a resource area that builds credibility for the sales team.",
    quote:
      "The new website brought 65% more organic traffic in 60 days and our WooCommerce store made 5 sales within 30 days — the resource area gives our sales team real credibility.",
    name: "Gary H.",
    role: "Sales Director, Crescent Design",
    intro:
      "Crescent Design manufactures industrial parts and tools — and needed a website that could sell them. Sixty days in, organic traffic was up 65%; thirty days after the WooCommerce launch, 5 online sales were on the board.",
    steps: [
      "A new website built for industrial buyers — organic traffic up 65% in 60 days",
      "A WooCommerce system selling online — 5 sales within the first 30 days",
      "A resource area that doubles as a credibility builder for the sales team",
    ],
  },
];

export const ALL_CASES = [...CASES, ...MORE_CASES];

// Nav grouping — second-level dropdown shows these categories; each flies out
// its member case studies on a third level. Every case sits in exactly one.
export const CASE_CATEGORIES = [
  {
    id: "home-services",
    label: "Home Services",
    hint: "HVAC, restoration & remodeling",
    slugs: [
      "vancouver-heating-and-air",
      "tsc-restoration",
      "on-the-level-remodeling",
      "floodmasters",
      "kc-electric",
      "kc-engineering",
    ],
  },
  {
    id: "real-estate",
    label: "Real Estate",
    hint: "Realty, commercial & investment",
    slugs: ["keller-williams-realty", "dlm-commercial", "coastline-investment-group"],
  },
  {
    id: "b2b",
    label: "BtoB Companies",
    hint: "Consulting, manufacturing & more",
    align: "high",
    slugs: [
      "bsg-advisors",
      "fully-promoted",
      "iq-manufacturing",
      "john-gervino",
      "interim-accounting-solutions",
      "plateau-semiconductor",
    ],
  },
  {
    id: "other",
    label: "Other",
    hint: "Retail, recreation & manufacturing",
    align: "high",
    slugs: ["rock-n-gold-creations", "fifty-two-perfect-days", "swim-swim-club", "crescent-design"],
  },
];

// Result chips — shown on the home case cards and on each case study's individual page.
export const CASE_STATS = {
  "vancouver-heating-and-air": [
    { big: "3x", small: "organic traffic in 90 days" },
    { big: "60", small: "new keywords ranked in 60 days" },
  ],
  "bsg-advisors": [
    { big: "+214%", small: "organic sessions year over year" },
    { big: "200%", small: "more sales" },
  ],
  "keller-williams-realty": [
    { big: "300%", small: "improvement in 60 days" },
    { big: "23", small: "new leads in 60 days" },
  ],
  "dlm-commercial": [
    { big: "4", small: "inquiries from organic search in 30 days" },
    { big: "100%", small: "optimized website in 45 days" },
  ],
  "fully-promoted": [{ big: "150%", small: "social growth in 90 days" }],
  "swim-swim-club": [
    { big: "5M", small: "social views a month", period: "up from 500k" },
    { big: "+30%", small: "new subscriptions", period: "first 90 days" },
  ],
  "crescent-design": [
    { big: "+65%", small: "organic traffic", period: "first 60 days" },
    { big: "5", small: "online sales", period: "first 30 days" },
  ],
  "tsc-restoration": [{ big: "+58%", small: "more qualified calls" }],
  "iq-manufacturing": [{ big: "2x", small: "inbound inquiries" }],
  "john-gervino": [{ big: "+120%", small: "demo requests" }],
  "interim-accounting-solutions": [
    { big: "+200%", small: "traffic in one quarter" },
  ],
  "rock-n-gold-creations": [
    { big: "2.5x", small: "traffic year over year" },
  ],
  "plateau-semiconductor": [{ big: "+100%", small: "inbound inquiries" }],
  "coastline-investment-group": [
    { big: "+75%", small: "lead inquiries in two quarters" },
  ],
  "fifty-two-perfect-days": [{ big: "+85%", small: "page views after launch" }],
  "on-the-level-remodeling": [{ big: "+60%", small: "quote requests" }],
  "kc-engineering": [
    { big: "-80%", small: "cost per click", period: "4-6 months" },
    { big: "+350%", small: "lead volume", period: "4-6 months" },
  ],
  "floodmasters": [
    { big: "+20%", small: "domain authority", period: "6 months" },
    { big: "500%", small: "more organic traffic", period: "6 months" },
  ],
  "kc-electric": [
    { big: "350%", small: "increase in local visibility" },
    { big: "18", small: "organic leads", period: "first 60 days" },
  ],
};

// Client-website captures shown in a browser frame on each individual case page.
// Cases absent from this map render a branded project-preview mockup instead.
export const CASE_SITES = {
  "dlm-commercial": { img: "/img/cases/dlm-commercial.jpg", url: "dlmcommercial.com" },
  "rock-n-gold-creations": { img: "/img/cases/rock-n-gold-creations.jpg", url: "customjewelry.com" },
  "iq-manufacturing": { img: "/img/cases/iq-manufacturing.jpg", url: "iqmanufacturing.com" },
  "john-gervino": { img: "/img/cases/john-gervino.jpg", url: "truthintelligence.com" },
  "fifty-two-perfect-days": { img: "/img/cases/fifty-two-perfect-days.jpg", url: "52perfectdays.com" },
  "fully-promoted": { img: "/img/cases/fully-promoted.jpg", url: "fullypromoted.com/locations/olathe-ks" },
  // Industry stock photos (labeled "Illustrative photo") for cases without a
  // usable client-site capture.
  "vancouver-heating-and-air": { img: "/img/cases/vancouver-heating-and-air.jpg", url: "Vancouver Heating and Air", stock: true },
  "bsg-advisors": { img: "/img/cases/bsg-advisors.jpg", url: "BSG Advisors", stock: true },
  "keller-williams-realty": { img: "/img/cases/keller-williams-realty.jpg", url: "Keller Williams Realty", stock: true },
  "tsc-restoration": { img: "/img/cases/tsc-restoration.jpg", url: "TSC Restoration", stock: true },
  "interim-accounting-solutions": { img: "/img/cases/interim-accounting-solutions.jpg", url: "Interim Accounting Solutions", stock: true },
  "plateau-semiconductor": { img: "/img/cases/plateau-semiconductor.jpg", url: "Plateau Semiconductor", stock: true },
  "coastline-investment-group": { img: "/img/cases/coastline-investment-group.jpg", url: "Coastline Investment Group", stock: true },
  "on-the-level-remodeling": { img: "/img/cases/on-the-level-remodeling.jpg", url: "On The Level Remodeling", stock: true },
};

// The blog guide that matches each case study's core service (shown as a
// "Related guide" card on the individual case page).
export const CASE_GUIDE = {
  "vancouver-heating-and-air": "home-services-content-kansas-city",
  "on-the-level-remodeling": "home-services-content-kansas-city",
  "bsg-advisors": "google-remarketing-adwords-and-adroll",
  "plateau-semiconductor": "google-remarketing-adwords-and-adroll",
  "keller-williams-realty": "website-optimization-should-you-use-ai",
  "dlm-commercial": "website-optimization-should-you-use-ai",
  "interim-accounting-solutions": "website-optimization-should-you-use-ai",
  "rock-n-gold-creations": "website-optimization-should-you-use-ai",
  "fifty-two-perfect-days": "website-optimization-should-you-use-ai",
  "fully-promoted": "facebook-ads-using-ai",
  "tsc-restoration": "facebook-ads-using-ai",
  "coastline-investment-group": "facebook-ads-using-ai",
  "swim-swim-club": "facebook-ads-using-ai",
  "crescent-design": "5-reasons-to-update-your-wordpress-website",
  "iq-manufacturing": "seo-and-local-geo",
  "john-gervino": "seo-and-local-geo",
  "kc-engineering": "google-ads-for-hvac-restoration-home-services",
  "floodmasters": "home-services-content-kansas-city",
  "kc-electric": "kansas-city-home-services-local-search",
};
